import React, {useEffect, useState} from 'react';
import {toast} from "react-toastify";
import Input from "../../../../components/common/Input";
import Button from "../../../../components/common/Button";
import FetchService from "../../../../services/api/FetchService";
import {IChecklistManagementResource} from "../../../../resources/IChecklistManagement.resource";
import {ErrorToastSettings} from "../../../../services/toast/toastSettings";
import EditableCell from "../EditableCell";
import styles from './styles.module.scss';

interface IProps {
    companyId: number;
    checklistId: number;
    name: string;
    description: string | null;
    onSaved: (updated: Pick<IChecklistManagementResource, 'name' | 'description'>) => void;
}

const ChecklistMetaEditor: React.FC<IProps> = ({companyId, checklistId, name, description, onSaved}) => {
    const [draftName, setDraftName] = useState<string>(name);
    const [draftDescription, setDraftDescription] = useState<string>(description ?? '');
    const [isSaving, setIsSaving] = useState<boolean>(false);

    useEffect(() => {
        setDraftName(name);
        setDraftDescription(description ?? '');
    }, [name, description]);

    const isDirty = draftName !== name || draftDescription !== (description ?? '');
    const isValid = draftName.trim() !== '';

    const handleSave = async () => {
        if (!isValid) return;

        try {
            setIsSaving(true);
            const {data} = await FetchService.putChecklistManagement(companyId, checklistId, {
                name: draftName,
                description: draftDescription || null,
            });
            onSaved({name: data.name, description: data.description});
        } catch (error) {
            toast.error('Не вдалося зберегти зміни', ErrorToastSettings);
            setDraftName(name);
            setDraftDescription(description ?? '');
        } finally {
            setIsSaving(false);
        }
    };

    return (
        <div className={styles.meta}>
            <Input
                placeholder={'Назва'}
                value={draftName}
                onChange={(e) => setDraftName(e.target.value)}
                disabled={isSaving}
            />
            <div className={styles.meta__description}>
                <span className={styles.meta__label}>Опис</span>
                <EditableCell
                    value={draftDescription}
                    disabled={isSaving}
                    onChange={setDraftDescription}
                />
            </div>
            {isDirty ? (
                <div className={styles.meta__actions}>
                    <Button
                        text={isSaving ? 'Збереження...' : 'Зберегти'}
                        onClick={handleSave}
                        disabled={!isValid || isSaving}
                    />
                </div>
            ) : null}
        </div>
    );
};

export default ChecklistMetaEditor;
